import { authRequest } from './utils';

const serializePrompt = (data) => ({
  ...data,
  // Backend accepts engagement as a uuid (SlugRelatedField).
  engagement: data?.engagement?.uuid || data?.engagement || null,
  questions: (data?.questions || []).map((q, idx) => ({
    id: q.id,
    order: q.order ?? idx,
    text: q.text,
  })),
});

// ---------- Interview Prompts ----------

export const getInterviewPrompts = async (config = undefined) => {
  const url = `admin/interview-prompts/`;
  return await authRequest.get(url, config);
};

export const getInterviewPrompt = async (uuid, config = undefined) => {
  const url = `admin/interview-prompts/${uuid}/`;
  return await authRequest.get(url, config);
};

export const postInterviewPrompt = async (data, config = undefined) => {
  const url = `admin/interview-prompts/`;
  return await authRequest.post(url, serializePrompt(data), config);
};

export const saveInterviewPrompt = async (uuid, data, config = undefined) => {
  const url = `admin/interview-prompts/${uuid}/`;
  return await authRequest.put(url, serializePrompt(data), config);
};

export const deleteInterviewPrompt = async (uuid, config = undefined) => {
  const url = `admin/interview-prompts/${uuid}/`;
  return await authRequest.delete(url, config);
};

// ---------- Interview Submissions ----------

export const getInterviewSubmissions = async (config = undefined) => {
  const url = `admin/interview-submissions/`;
  return await authRequest.get(url, config);
};

export const getInterviewSubmission = async (uuid, config = undefined) => {
  const url = `admin/interview-submissions/${uuid}/`;
  return await authRequest.get(url, config);
};

export const deleteInterviewSubmission = async (uuid, config = undefined) => {
  const url = `admin/interview-submissions/${uuid}/`;
  return await authRequest.delete(url, config);
};
